import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import fetcher from "../../common/axiosInstance";
import { SECURE_COOKIE } from "@globalConfig";
import useCookieClient from "@hooks/useCookieClient";
export var unbxdAnalytics = function unbxdAnalytics(data) {
  //!!warning!! this was needed for unbxd but not for TypeSense
  //if (data.action !== "visitor" && !data.requestId) return;
  var _getOrCreateUnbxdUser = getOrCreateUnbxdUserId(),
    uid = _getOrCreateUnbxdUser.uid,
    isNew = _getOrCreateUnbxdUser.isNew;
  var _useCookieClient = useCookieClient(),
    getCookieClient = _useCookieClient.getCookieClient,
    setCookieClient = _useCookieClient.setCookieClient;
  data.uid = uid;
  data.visit_type = isNew ? "first_time" : "repeat";
  var visitId = getCookieClient("visitId");
  if (!visitId) {
    visitId = "visitId-".concat(new Date().getTime(), "-").concat(Math.floor(Math.random() * 100000));

    // Create a date object for the current time
    var currentDate = new Date();

    // Set the cookie to expire 30 minutes from now
    var expireTime = new Date(currentDate.getTime() + 30 * 60000); // 60000 milliseconds in a minute

    // Save the cookie with the expiration time
    setCookieClient("visitId", visitId, {
      path: "/",
      expires: expireTime,
      sameSite: true,
      secure: SECURE_COOKIE
    });
  }
  var trackPayload = _objectSpread(_objectSpread({}, data), {}, {
    visitId: visitId,
    referrer: getReferralURL()
  });

  // search-lab does not expose track; always use the legacy path.
  fetcher(null, true).post("/search/track", trackPayload)["catch"](function (e) {
    return Promise.resolve("Ignore search analytics error");
  });
};
export function getReferralURL() {
  // Check if running in a browser environment
  if (typeof window !== "undefined" && window.dataLayer) {
    // Filter the dataLayer array for 'gtm.historyChange' events

    var filtered = window.dataLayer.filter(function (s) {
      return s.event === "gtm.historyChange";
    });
    if (filtered.length > 0) {
      var _filtered$gtmOldUrl, _filtered;
      // Access the last element's 'gtm.oldUrl' property and decode it
      var lastUrl = decodeURI((_filtered$gtmOldUrl = (_filtered = filtered[filtered.length - 1]) === null || _filtered === void 0 ? void 0 : _filtered["gtm.oldUrl"]) !== null && _filtered$gtmOldUrl !== void 0 ? _filtered$gtmOldUrl : "");
      return lastUrl;
    }
  }

  // Fall back to document.referrer if available
  if (typeof document !== "undefined" && document.referrer) {
    return document.referrer;
  }

  // Return empty string if no referrer is found
  return "";
}
export var getOrCreateUnbxdUserId = function getOrCreateUnbxdUserId() {
  var _useCookieClient2 = useCookieClient(),
    getCookieClient = _useCookieClient2.getCookieClient,
    setCookieClient = _useCookieClient2.setCookieClient;
  var UUID = getCookieClient("UUID");
  var isUnbxdNewUser = false;
  if (!UUID) {
    UUID = "uid-".concat(new Date().getTime(), "-").concat(Math.floor(Math.random() * 100000));
    isUnbxdNewUser = true;
    setCookieClient("UUID", UUID, {
      path: "/",
      maxAge: 3600 * 24 * 365 * 10,
      sameSite: true,
      secure: SECURE_COOKIE
    });
  }
  return {
    uid: UUID,
    isNew: isUnbxdNewUser
  };
};